<template lang="pug">
li.space(
  v-bind:data-prefecture-id='space.prefecture.id'
)
  .cover
    .main
      .title
        .type(v-if="space.space_type_sym")
          i.font-awesome-icon(v-bind:class="['fa', spaceTypeIcon]")
          | {{space.space_type_name}}
        a.name(v-bind:href="'/spaces/' + space.name_url")
          | {{space.name}}
        .address {{space.prefecture.name}}{{space.city.name}}{{space.address}}
      a.image(v-bind:href="'/spaces/' + space.name_url")
        img(v-bind:src="space.display_image_main_wide_medium")
      .latest-article(v-if="space.recent_article")
        a(v-bind:href="space.recent_article.custom_show_url")
          | [NEW] {{space.recent_article.title}}（{{space.recent_article.created_at}}）
      .latest-article(v-else)
        | 最新のお知らせはありません
    .catchimage
      .data.registed
        p.games
          | 遊べるボードゲーム
          a(v-bind:href="'/spaces/' + space.name_url + '/games'")
            | {{space.ourgames_size}}個
        p.catchcopy {{space.catchcopy}}
        .follow-buttons
          button.watch(
            v-if="space.current_user_followable"
            v-bind:class="{ on: space.current_user_following }"
            v-on:click="toggleFollow"
          )
            i.font-awesome-icon(class="fa fa-rss")
            | {{ space.current_user_following ? 'フォロー中' : 'フォローする' }}
</template>

<script>
export default {
  props: {
    initialSpace: {
      type: Object,
      default: () => ({})
    }
  },
  data: function() {
    return {
      space: this.initialSpace,
    };
  },
  computed: {
    spaceTypeIcon: function() {
      const space_type_icons = {
        cafe: 'fa-coffee',
        space: 'fa-object-ungroup',
        bar: 'fa-glass-martini',
        other: 'fa-shopping-cart'
      };
      return space_type_icons[this.space.space_type_sym];
    },
  },
  methods: {
    toggleFollow: function() {
      this.$emit('toggle-follow', this.space);
    }
  },
};
</script>

<style scoped lang="scss">
@import "app/assets/stylesheets/_mixin.scss";
@import "app/assets/stylesheets/_variable.scss";
.watch {
  @include border-radius();
  font-size: $common-normal;
  font-weight: bold;
  border: 1px solid #ddd;
  color: #333;
  background-color: #fff;
  padding: 12px 0;
  text-decoration: none;
  display: block;
  width: 100%;
  i.font-awesome-icon {
    color: #ccc;
  }
  &:hover {
    color: $common-orange;
    i.font-awesome-icon {
      color: $common-orange;
    }
  }
  &.on {
    @include text-shadow();
    background-color: $common-orange;
    color: #fff;
    border-color: adjust-color($common-orange, $red: -34, $green: -34, $blue: -34);
    i.font-awesome-icon {
      color: #fff;
    }
    &:hover {
      background-color: adjust-color($common-orange, $red: 34, $green: 34, $blue: 34);
    }
  }
}
</style>
